// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/example-function-get-blob').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-function-get-blob/build.source.js
// module id = 281
// module chunks = 1